import React, { useState, useEffect } from "react";
/*import { Helmet } from "react-helmet";*/
import { Link } from "react-router-dom";
import { Row, Col, Card, Statistic, Skeleton, Empty, Alert } from "antd";
import { BookOutlined, SearchOutlined, FileTextOutlined } from "@ant-design/icons";
import BannerBar from "../../../components/Bannerbar";
import RenderHelmet from "../../../components/RenderHelmet";
import { getSumario } from "../../../services/constituicaoAPI";
import style from "./style.module.css";

const PREAMBULO = `Nós, representantes do povo brasileiro, reunidos em Assembléia Nacional Constituinte para instituir um Estado Democrático, destinado a assegurar o exercício dos direitos sociais e individuais, a liberdade, a segurança, o bem-estar, o desenvolvimento, a igualdade e a justiça como valores supremos de uma sociedade fraterna, pluralista e sem preconceitos, fundada na harmonia social e comprometida, na ordem interna e internacional, com a solução pacífica das controvérsias, promulgamos, sob a proteção de Deus, a seguinte CONSTITUIÇÃO DA REPÚBLICA FEDERATIVA DO BRASIL.`;

export default function ConstituicaoSumario() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sumario, setSumario] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        setError(null);
        const data = await getSumario();
        setSumario(data);
      } catch (err) {
        setError(err?.message || "Erro ao carregar Constituição");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) {
    return (
      <>
        <BannerBar customText="/legislação federal" />
        <div className="container mt-5 mb-5">
          <Skeleton active paragraph={{ rows: 8 }} />
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <BannerBar customText="/legislação federal" />
        <div className="container mt-5 mb-5">
          <Alert type="error" message={error} description="Verifique sua conexão e tente novamente." showIcon />
        </div>
      </>
    );
  }

  const titulos = sumario?.titulos || [];
  const totalArtigos = sumario?.totalArtigos ?? 0;
  const totalDispositivos = sumario?.totalDispositivos ?? 0;

  return (
    <>
      <BannerBar customText="/legislação federal" />
      <div className="container mt-5 mb-5">
        <RenderHelmet
          title="Constituição Federal de 1988 - Cadê Direito"
          description="Constituição da República Federativa do Brasil de 1988 - Navegação completa por títulos, capítulos e artigos."
        />

        <div className={style.headerConstituicao}>
          <h1 className={style.tituloPrincipal}>
            CONSTITUIÇÃO DA REPÚBLICA FEDERATIVA DO BRASIL DE 1988
          </h1>
          <p className={style.subtitulo}>Navegação completa por títulos, capítulos e artigos</p>
        </div>

        <Row gutter={[24, 24]} className={style.statsRow}>
          <Col xs={24} sm={12} md={8}>
            <Card>
              <Statistic
                title="Artigos"
                value={totalArtigos}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card>
              <Statistic
                title="Dispositivos"
                value={totalDispositivos}
                prefix={<BookOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Link to="/legislacao/federal/pesquisar" className={style.linkPesquisa}>
            <Card className={style.cardPesquisa} hoverable>
                <SearchOutlined className={style.iconPesquisa} />
                <span>Pesquisar na Constituição</span>
            </Card>
            </Link>
          </Col>
        </Row>

        <div className={style.preambulo}>
          <h2 className={style.preambuloTitulo}>PREÂMBULO</h2>
          <p>{PREAMBULO}</p>
        </div>

        <div className={style.sumario}>
          <h2 className={style.sumarioTitulo}>Sumário - Títulos</h2>
          {titulos.length === 0 ? (
            <Empty description="Nenhum título disponível" />
          ) : (
            <Row gutter={[16, 16]}>
              {titulos.map((titulo) => (
                <Col key={titulo.id} xs={24} sm={12} lg={8}>
                  <Link to={`/legislacao/federal/${titulo.url}`} className={style.cardLink}>
                    <Card className={style.cardTitulo} hoverable>
                      <span className={style.tituloLabel}>{titulo.titulo}</span>
                      <span className={style.tituloTexto}>{titulo.texto}</span>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>
    </>
  );
}
